import { createEffect } from 'effector';
import { getGeoBuckets } from '../../utils/gradient-utils.js';
import { api } from '../../api/axiosinstance.js';

export const bucketsByAlgorithmFx = createEffect().use(
  async ({ hexagons, algorithm }) => {
    return {
      buckets: await getGeoBuckets(hexagons, 'JNK'),
    };
  }
);
